var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSofa2SeaterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 224.922,
    height: 159.906,
    viewBox: "0 0 224.922 159.906",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sofa_2_seater-icon",
    "data-name": "sofa 2 seater-icon",
    transform: "translate(-7296 3000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M7367.135-3000H7496.29a16.509,16.509,0,0,0,1.7.383,28.238,28.238,0,0,1,18.419,9.656c6.823,7.789,8.579,16.857,6.584,26.873a3.606,3.606,0,0,1-2.963,3.3c-9.6,2.876-15.839,9.226-18.069,19.05-2.071,9.123-3.732,18.338-5.633,27.5-.758,3.653-3.081,5.556-6.815,5.559q-56.446.032-112.894,0c-3.853,0-6.12-1.883-6.909-5.714-1.783-8.664-3.422-17.359-5.248-26.014-2.337-11.084-8.976-18.261-20.076-20.737-2.7-.6-3.443-1.7-3.932-4.085a29.349,29.349,0,0,1,19.671-34.17C7362.395-2999.136,7364.794-2999.478,7367.135-3000Z",
    transform: "translate(-24.569)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M7520.922-2879.063v6.589a15.646,15.646,0,0,0-.356,1.894c-.341,5.035-.645,10.073-.976,15.11-.464,7.079-.576,14.206-1.49,21.227-1.877,14.427-13.875,24.6-28.531,24.6q-81.107.021-162.215,0c-.658,0-1.316,0-1.975-.031-13.792-.563-25.942-12.336-26.757-25.87q-.865-14.347-1.845-28.687c-.176-2.608-.514-5.206-.778-7.808v-7.029a3.446,3.446,0,0,0,.388-.745c2.218-9.187,9.706-15.228,18.571-14.966,8.989.265,16.156,6.563,17.971,15.733q2.511,12.691,5.109,25.363c1.692,8.188,6.561,12.093,14.975,12.1q17.347.014,34.693,0,38.316,0,76.632-.007c7.82-.006,12.944-4.169,14.465-11.655,1.863-9.168,3.561-18.372,5.624-27.495a18.333,18.333,0,0,1,17.309-14.02,18.744,18.744,0,0,1,18.2,12.617C7520.28-2881.117,7520.594-2880.088,7520.922-2879.063Z",
    transform: "translate(0 -58.995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M7364.035-2663.353a30.882,30.882,0,0,1-4.069-1.52,10.086,10.086,0,0,1-5.122-10.942c.542-3.008,1.42-5.955,2.158-8.969h21.424c-.448,1.934-.851,3.737-1.287,5.533-.466,1.915-1.088,3.8-1.424,5.737-.952,5.487-4.077,8.868-9.483,10.161Z",
    transform: "translate(-32.891 -176.742)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M7707.4-2663.267c-5.771-1.314-8.632-5.148-9.667-10.788-.644-3.5-1.664-6.933-2.559-10.576h21.612c.705,3.506,1.811,7.156,2.092,10.868.354,4.675-3.086,8.781-7.623,10-.557.15-1.105.328-1.658.493Z",
    transform: "translate(-223.814 -176.827)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofa2SeaterIcon);
export default __webpack_public_path__ + "static/media/sofa 2 seater-icon.6c776e5d8a3d9cb0f9a237477208f1c0.svg";
export { ForwardRef as ReactComponent };